import React from "react";
import {
  Dialog,
  DialogContent,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme,
  Stack,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import { GradientButton } from "./button/GradientButton";

interface GuestLightModalProps {
  open: boolean;
  onClose: () => void;
}

const GuestLiteModal: React.FC<GuestLightModalProps> = ({ open, onClose }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();

  const handleUpgradeClick = () => {
    onClose();
    navigate("/settings");
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: 3,
          px: { xs: 3, sm: 5 },
          py: { xs: 4, sm: 5 },
        },
      }}
    >
      {/* Close button */}
      <IconButton
        onClick={onClose}
        sx={{
          position: "absolute",
          top: 12,
          right: 12,
          color: "grey.500",
        }}
      >
        <CloseIcon />
      </IconButton>

      {/* Content */}
      <DialogContent>
        <Stack spacing={3} textAlign="center">
          <Typography
            fontFamily="Lexend"
            fontWeight={800}
            variant={isMobile ? "h5" : "h4"}
            sx={{
              background:
                "linear-gradient(90deg, var(--primary-600) 0%, var(--secondary-purple) 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            TaaSNet
          </Typography>

          <Typography variant="body1" color="text.secondary">
            You're currently using a guest lite profile. Add all your profile
            details to upgrade your account to access this feature.
          </Typography>

          <GradientButton onClick={handleUpgradeClick}>
            Upgrade Profile
          </GradientButton>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default GuestLiteModal;
